import React from "react";
import Store from "../SessionStorage";
import { sessionStorageAction } from "Utilities";

import { GiCityCar } from "react-icons/gi";
import { IoBuild } from "react-icons/io5";

const Vehicle = ({ isLoggedIn, brandText, modelText, immatriculation, version }) => {
  const displayedBrand = isLoggedIn ? Store.get(sessionStorageAction.dashboard.vehicle.brandText) : brandText;
  const displayedModel = isLoggedIn ? Store.get(sessionStorageAction.dashboard.vehicle.modelText) : modelText;
  const displayedImmatriculation = isLoggedIn ? Store.get(sessionStorageAction.dashboard.vehicle.immatriculation) : immatriculation;
  const displayedVersion = isLoggedIn ? Store.get(sessionStorageAction.dashboard.vehicle.version) : version;

  return (
    <div className="admin-dashboard-infos-container">
      <div className="admin-dashboard-infos-line">
        <div className="admin-dashboard-infos-icon">
          <GiCityCar size={28} />
        </div>
        <span className="admin-dashboard-infos-text">
          {displayedBrand}
          &nbsp;
          {displayedModel}
        </span>
      </div>
      <div className="admin-dashboard-infos-line">
        <div className="admin-dashboard-infos-icon">
          <IoBuild size={20} />
        </div>
        <span className="admin-dashboard-infos-text">
          {displayedVersion}
        </span>
      </div>
      <div className="admin-dashboard-infos-line">
        <div className="admin-dashboard-infos-icon" />
        <div className="admin-dashboard-infos-immat">
          <div className="admin-dashboard-infos-immat-side"/>
          <div className="admin-dashboard-infos-immat-text">
            {displayedImmatriculation}
          </div>
          <div className="admin-dashboard-infos-immat-side"/>
        </div>
      </div>
    </div>
  )
};

export default Vehicle;